import { PushNotifications } from '@capacitor/push-notifications';
import { AppContext } from '../Context';
import { Fragment, useState, useRef, useEffect, useContext } from 'react';
//import { Clipboard } from '@capacitor/clipboard';
import { isPlatform } from '@ionic/core';
// import { FCM } from "@capacitor-community/fcm";
import { LocalNotifications, PendingLocalNotificationSchema, Schedule, ScheduleOptions, PermissionStatus } from '@capacitor/local-notifications';
import { IonDateString } from '../components/IonDate';

//classes
import Notification from '../classes/notification';
import MemberUser from '../classes/memberUser';


//controllers
import DatabaseInterfaceController from './DatabaseInterfaceController';

//graphics
import EnableNotificationTutorial from '../assets/gifs/enableNotificationTutorial.gif';

interface Props {
    localNotifications: Notification[], SetLocalNotifications: any,
    shouldClearAllPendings: boolean, SetShouldClearAllPendings: any,
    SetNotificationMode: any
}

const NotificationsController: React.FC<Props> = ({ localNotifications, SetLocalNotifications, shouldClearAllPendings, SetShouldClearAllPendings, SetNotificationMode }) => {
    //context
    const appContext = useContext(AppContext);
    //refs
    const prevUserRef = useRef<MemberUser>({} as MemberUser);
    //refs - actions
    const pushNotificationsRegisrationActionRef = useRef<any>((token: any) => {
        let platform = '';
        if(isPlatform('android'))
            platform = 'android';
        else if(isPlatform('ios'))
            platform = 'ios';
        else
            platform = 'other';

        //the frame delay will make sure prevUserRef is set to latest appContext.user
        requestAnimationFrame(() => {
            databaseInterfaceController.Queue('registerDevicePushToken', [
                ['registerDevicePushToken', 'true'],
                ['userID', prevUserRef.current.userID],
                ['token', token.value],
                ['platform', platform],
                ['last_login', IonDateString(new Date())]
            ]);
        });
    });
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    useEffect(() => {
        if (isPlatform('hybrid')) {
            //all 3 of these are for push notifications
            // RegisterNotifications();
            // AddRegistrationResultsListeners();
            // GetDeliveredNotifications();
        }
    }, []);

    //watch for user relogin/ login, update pushNotifications token
    useEffect(() => {
        if(isPlatform('hybrid')) {
            if(JSON.stringify(prevUserRef.current) != JSON.stringify(appContext.user)) {
                if(Object.keys(appContext.user).length > 0 && Object.keys(prevUserRef.current).length == 0) {
                    const RequestPushPermission = async() => {
                        const permission = await PushNotifications.requestPermissions();
    
                        if (permission.receive == 'granted') {
                          // Now register the device
                          await PushNotifications.register();
                        } else {
                          appContext.SetPopupMessage("Push notification permission not granted.");
                        }
                    };
                    PushNotifications.removeAllListeners();
                    PushNotifications.addListener('registration', pushNotificationsRegisrationActionRef.current);
    
                    RequestPushPermission();
                }
                prevUserRef.current = appContext.user;
            }
        }
    }, [appContext.user]);

    //copy to clipboard's for testing
    // useEffect(() => {
    //     if(token != '') {
    //         const CopyToClipboard = async() => {
    //             await Clipboard.write({
    //                 string: token
    //             }).then(() => {
    //                 alert('successfully copied!');
    //             }).catch((err: string) => {
    //                 alert('snot copied! ' + err);
    //             });
    //         }
    //         CopyToClipboard();
    //     }
    // }, [token]);

    //listen to localNotificationChange
    useEffect(() => {
        // alert('notifications changed!:' + JSON.stringify(localNotifications));
        if (isPlatform('hybrid') && localNotifications.length > 0) {
            //check for notification permission
            LocalNotifications.checkPermissions().then((permissionStatus: PermissionStatus) => {
                if (permissionStatus.display == 'granted') {
                    //schedule notifications
                    localNotifications.map(async (localNotification: Notification) => {
                        await ScheduleLocalNotification(
                            localNotification.title, localNotification.body, localNotification.largeBody, localNotification.dateTime
                        );
                    });
                } else {
                    LocalNotifications.requestPermissions().then((permissionStatus: PermissionStatus) => {
                        if (permissionStatus.display == 'granted') {
                            //force reupdate of localNotifications, to go through the process all over again, to schedule notifications
                            SetLocalNotifications([...localNotifications]);

                        } else if (permissionStatus.display == 'denied') {
                            //alert('permission denied!');
                            //notification schedule prohibited
                            appContext.SetPopupInstructions(['please allow app notification for the schedule reminder to work.']);
                            appContext.SetPopupPreviews([EnableNotificationTutorial]);
                            SetNotificationMode(0);
                        }
                    }).catch((err) => {
                        //alert('permission error: ' + err);
                        //notification schedule prohibited
                        appContext.SetPopupInstructions(['please allow app notification for the schedule reminder to work.']);
                        appContext.SetPopupPreviews([EnableNotificationTutorial]);
                        SetNotificationMode(0);
                    });
                }
            });
        }
    }, [localNotifications]);

    //clear pendings on request
    useEffect(() => {
        if (isPlatform('hybrid') && shouldClearAllPendings) {
            const RemoveAllPendingsAction = async () => {
                await RemoveAllPendings();
                SetShouldClearAllPendings(false);
            };
            RemoveAllPendingsAction();
        }
    }, [shouldClearAllPendings]);

    //watch for databaseResultActions
    useEffect(() => {
        if(appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async() => {
                const [res, mode] = await appContext.databaseResultAction();
                switch(mode) {
                    case 'registerDevicePushToken':
                        if(!JSON.stringify(res).includes('_false')) {
                            console.log('registerDevicePushTokenSuccess: ' + res);
                        } else {
                            console.log('registerDevicePushTokenErr: ' + res);
                        }
                        break;
                }
            }
            switch(appContext.databaseActionModeQueue[0]){
                case 'registerDevicePushToken':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //Push Notification Exe
    //these methods are called, when PushNotification Services Registered Successfully or with error
    // const AddRegistrationResultsListeners = async () => {
    //     await PushNotifications.addListener('registration', token => {
    //         if (isPlatform('ios')) {
    //             FCM.getToken().then((res) => {
    //                 //alert('Registration token2: ' + res.token);
    //                 SetToken(res.token);
    //             });
    //         } else if (isPlatform('android')) {
    //             //alert('is in android');
    //             SetToken(token.value);
    //         }
    //     });

    //     await PushNotifications.addListener('registrationError', err => {
    //         //alert('Registration error: ' + err.error);
    //     });

    //     await PushNotifications.addListener('pushNotificationReceived', notification => {
    //         //alert('Push notification received: ' + notification);
    //     });

    //     //handles when notification clicked!
    //     await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
    //         //alert('Push notification action performed' + notification.actionId + ";" + notification.inputValue);
    //         //alert('action performed!');
    //     });
    // }
    //Register the app to receive push notifications.
    // const RegisterNotifications = async () => {
    //     let permStatus = await PushNotifications.checkPermissions();

    //     if (permStatus.receive === 'prompt') {
    //         permStatus = await PushNotifications.requestPermissions();
    //     }

    //     if (permStatus.receive !== 'granted') {
    //         //alert('User denied permissions!');
    //     }

    //     await PushNotifications.register();
    // }
    //Get a list of notifications that are visible on the notifications screen.
    // const GetDeliveredNotifications = async () => {
    //     const notificationList = await PushNotifications.getDeliveredNotifications();
    //     //alert('delivered notifications' + notificationList);
    // }

    //Local Notifications Exe
    const ScheduleLocalNotification = async (title: string, body: string, largeBody: string, dateTime: Date) => {
        const schedule: Schedule = {
            repeats: false,
            at: dateTime
        };
        const pendings = await LocalNotifications.getPending().then((res) => { return res }) as PendingLocalNotificationSchema[];
        //get a new unique id that doesn't overlap
        const newId = await GenerateUniqueNotificationId(pendings);
        await LocalNotifications.schedule({
            notifications: [
                {
                    title: title,
                    body: body,
                    largeBody: largeBody,
                    id: newId,
                    schedule: schedule,
                    largeIcon: "notification_icon",
                    smallIcon: "notification_icon"
                }
            ]
        }).then(() => {
            console.log('local notification scheduled!');
        }).catch((err) => {
            console.log('local notification err:: ' + err);
        });
    }
    const RemoveAllPendings = async () => {
        const pendings = await LocalNotifications.getPending().then((res) => { return res }) as PendingLocalNotificationSchema[];
        await LocalNotifications.cancel({ notifications: pendings });
    }
    const GenerateUniqueNotificationId = async (pendings: PendingLocalNotificationSchema[]) => {
        let pass = false;
        let foundId = 0;
        while (!pass) {
            pass = true;
            foundId = Math.floor(100000000 + Math.random() * 900000000);
            for (let i = 0; i < pendings.length; i++) {
                const notification: PendingLocalNotificationSchema = pendings[i];
                if (foundId == notification.id) {
                    pass = false;
                    break;
                }
            }
        }
        return foundId;
    }

    return (<Fragment />)
};

export default NotificationsController;